<script>

export default {
  name: 'AdminView',
  mounted() {
    document.location.href="https://admin.casejeux.com/";
  },
}
</script>
